@if (isInitialized) {
  <oe-flat-widget [modalComponent]="modalComponent" [icon]="{name:'swap-vertical-outline', color:'normal'}"
    [title]="component.alias">
    <oe-flat-widget-line [name]="'GENERAL.MODE' | translate" [value]="mode"
      [converter]="CONVERT_TO_MODE">
    </oe-flat-widget-line>
    @if (mode === 3) {
    <oe-flat-widget-line [value]="tariffState"
                         [converter]="CONVERT_TARIFF_STATE"></oe-flat-widget-line>
    }
  </oe-flat-widget>
}
